import { observer } from 'mobx-react-lite'
import ShareDocumentDialogExportStore from '../export/ShareDocumentDialogExportStore'
import GapAutocompleteSingle from 'features/gap-components/autocomplete/single/GapAutocompleteSingle'
import { useShareDocumentDialogStore } from '../ShareDocumentDialogStore'

interface ShareDocumentDialogFYISelectClientProps {
   shareDocumentDialogExportStore: ShareDocumentDialogExportStore
}

export default observer(function ShareDocumentDialogFYISelectClient(props: ShareDocumentDialogFYISelectClientProps) {
   const { shareDocumentDialogExportStore } = props
   const shareDocumentDialogStore = useShareDocumentDialogStore()
   const { advisorIntegrationFYIStore } = shareDocumentDialogExportStore.sp
   const isLoadingClients = advisorIntegrationFYIStore.clientLoader.isLoading

   return shareDocumentDialogStore.formHandler.selectedFYIClientId.bindInput(ip =>
      <GapAutocompleteSingle
         sx={{ mt: 2 }}
         loading={isLoadingClients}
         options={shareDocumentDialogExportStore.FYIClientOptions}
         label="Client*"
         value={ip.value}
         onChange={ip.onChange}
         helperText={isLoadingClients ? 'Loading clients…' : 'Select the matching client in FYI'}
         error={ip.error}
      />
   )
})
